import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram } from '@fortawesome/free-brands-svg-icons';
import NavLink from '@/components/NavLink';

export default function MobileMenu({ links, onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      <div className="bg-blue-900 text-white w-64 max-w-full p-6 shadow-lg transform transition-transform duration-300 ease-in-out translate-x-0">
        <nav className="flex flex-col mt-8 space-y-4">
          {links.length > 0 ? (
            links.map((link) => (
              <NavLink key={link.to} to={link.to} text={link.text} onClose={onClose} />
            ))
          ) : (
            <p>Cargando...</p>
          )}
        </nav>
        <div className="flex justify-center mt-8 space-x-4">
          <a href="https://www.facebook.com/elarcoirisva" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gray-300">
            <FontAwesomeIcon icon={faFacebookF} size="lg" />
          </a>
          <a href="https://www.instagram.com/elarcoiris_va/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gray-300">
            <FontAwesomeIcon icon={faInstagram} size="lg" />
          </a>
        </div>
      </div>
      <div className="flex-1 bg-black bg-opacity-50" onClick={onClose}></div>
    </div>
  );
}
